import styles from './contactUs.module.scss'
import { Text } from 'typography/text'
import { useSiteAddress } from 'app/hooks/useSiteAddress'
import { PageSection } from 'layout/pageSection'
import { Container } from 'layout/container'
import { SitePhone } from 'common/sitePhone'
import { SiteEmail } from 'common/siteEmail'

const ContactUsSection = () => {
  const siteAddress = useSiteAddress()

  return (
    <PageSection className={styles.contactUs} id={'contacts'}>
      <Container className={styles.contactUs__container} noPadding="md">
        <div className={`${styles.contactUs__wrapper}`}>
          <div className={styles.contactUs__textBlock}>
            <h2 className={`h2 ${styles.contactUs__title}`}>Contact us</h2>
            <Text className={`${styles.contactUs__text}`}>
              <p>
                Our mission is to serve our clients by providing exceptional customer service and
                significantly discounted airfare. You can contact us anytime by calling our
                toll-free number, by email, or by completing the request form.
              </p>
            </Text>
            <div className={styles.contactUs__contacts}>
              <div className={styles.contactUs__contactRow}>
                <div className={styles.contactUs__contactItem}>
                  <SiteEmail />
                </div>
                <div className={styles.contactUs__contactItem}>
                  <SitePhone />
                </div>
              </div>
              <div className={styles.contactUs__socialRow}>
                <div className={styles.contactUs__socialLink}>
                  <a
                    href="https://www.facebook.com/DiscountFares1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/static/img/contactUs/f.svg" alt="" />
                  </a>
                </div>
                <div className={styles.contactUs__socialLink}>
                  <a
                    href="https://www.instagram.com/discountfares"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/static/img/contactUs/i.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
            <p className={styles.contactUs__address}>{siteAddress}</p>
          </div>
          <div className={styles.contactUs__imageContainer}>
            <img src="/static/img/contactUs/work.jpg" alt="" />
          </div>
        </div>
      </Container>
    </PageSection>
  )
}

export { ContactUsSection }
